'use client';
const footerLinks = {
  Product: [
    { label: 'Briefing', href: '#features' },
    { label: 'Explore', href: '#features' },
    { label: 'Ask', href: '#features' },
    { label: 'Act', href: '#features' },
  ],
  Company: [
    { label: 'About', href: '#' },
    { label: 'Careers', href: '#' },
    { label: 'Contact', href: 'mailto:hello@supe.market' },
  ],
  Resources: [
    { label: 'Documentation', href: '#' },
    { label: 'API Reference', href: '#' },
    { label: 'Blog', href: '#' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
    { label: 'Security', href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t border-border py-12 sm:py-16" role="contentinfo">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 mb-4 sm:col-span-4 lg:col-span-1 lg:mb-0">
            <a
              href="/"
              className="inline-flex items-center gap-0.5 text-lg text-foreground"
              aria-label="Supe.Market home"
            >
              <span className="font-serif font-semibold">supe</span>
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" />
              <span className="font-serif font-semibold">market</span>
            </a>
            <p className="mt-3 max-w-xs text-sm text-muted-foreground">
              Revenue expansion infrastructure for India&apos;s FMCG leaders.
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <nav key={title} aria-label={`${title} links`}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-foreground">
                {title}
              </h3>
              <ul className="mt-4 space-y-2.5" role="list">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 border-t border-border pt-6">
          <p className="text-center text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Supe.Market. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
